import React, { useEffect, useState } from 'react'
import { filterBlockByType } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const Video = ({ block }) => {
    const urlParts = block.attributes.URL.split('/')
    const videoId = urlParts[urlParts.length - 1]
    const titleBlock = filterBlockByType(block?.childrens, 'Titre')
    const creditBlock = filterBlockByType(block?.childrens, 'Credits')
    const blockWithoutTitleAndCredit = block?.childrens.filter(
        (b) => b.block !== 'Titre' && b.block !== 'Credits' && b.block !== 'Source'
    )
    const [videoSrc, setVideoSrc] = useState(null)

    useEffect(() => {
        if (block.attributes.URL.includes('youtu')) {
            setVideoSrc(`https://www.youtube.com/embed/${videoId}`)
        } else if (block.attributes.URL.includes('dailymotion')) {
            setVideoSrc(`https://www.dailymotion.com/embed/video/${videoId}`)
        }
    }, [block.attributes.URL, videoId])

    return (
        <div className="baseocom-video-block">
            <h4>
                {icon('video')} Vidéo - {titleBlock?.content}
            </h4>
            <iframe
                width="560"
                height="400"
                src={videoSrc}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
            <p>Crédits: {creditBlock?.childrens[0]?.content}</p>
            <Parser content_block={blockWithoutTitleAndCredit} />
        </div>
    )
}

export default Video
